var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[(
      _vm.component.componentType == 'multiSelectionGroup' ||
      _vm.component.componentType == 'onlySelectionGroup'
    )?_c('only-selection-group',{attrs:{"component":_vm.component},model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }